import { CategoryId, CategoryResponse } from '@business/entities/category';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';

export function fetchCategories() {
  return Endpoint.get<CategoryResponse[]>(`@gc/category`);
}

export function fetchCategory(id: CategoryId) {
  return Endpoint.get<CategoryResponse>(`@gc/category/category/${id}`);
}

export function createCategory(data: Partial<CategoryResponse>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<CategoryResponse>(`@gc/category`, { formData, hasFiles: true });
}

export function updateCategory(id: CategoryId, data: Partial<CategoryResponse>) {
  return Endpoint.patch<CategoryResponse>(`@gc/category/${id}`, { data });
}

export function deleteCategory(id: CategoryId) {
  return Endpoint.delete<void>(`@gc/category/${id}`);
}

export function syncCategories() {
  return Endpoint.get<CategoryResponse[]>(`@gc/category/sync`);
}
